<template>
  <div class="place" v-if="workplaces">
    <div>
      <svg id="root" class="apartments-b-house svg-content" width="712" height="650" viewBox="0 0 712 650" preserveAspectRatio="xMinYMin meet">
        <use id="Фон2" xlink:href="#_Image1" x="0" y="0" width="100%" height="100%"/>
        <g v-for="workplace in workplaces" :key="workplace.id"
           v-html="getWorkplaceHtml(workplace)"
           class="workplaces"
        >
        </g>
        <defs>
          <image id="_Image1" :xlink:href="background"/>
        </defs>
      </svg>
      <div class="bottom" v-if="zones">
        <div class="bottom__item" v-for="zone in zones" :key="zone.id">
          <div class="circle" :style="{'background-color': zone.color}"></div>
          <span>{{ zone.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Workplaces",
  data() {
    return {
      zones: null,
      workplaces: null,
      background: null,
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    show() {
      return this.zones && this.workplaces;
    }
  },
  mounted() {
    setTimeout(() => {
      this.loadZones().loadCoworking().loadWorkplaces();
    }, 100);
  },
  methods: {
    parseHTML(str) {
      var dom = document.createElement('div');
      dom.innerHTML = str;
      return dom.children[0];
    },
    getWorkplaceHtml(workplace) {
      let circle = this.parseHTML(workplace.path);
      return `${workplace.path}<text x="${circle.getAttribute('cx')}" y="${circle.getAttribute('cy')}"
              text-anchor="middle" stroke="#000" stroke-width="2px" dy=".3em">${workplace.number}</text>`;
    },
    loadZones() {
      this.$api.coworking.zone.list(this.getUser.coworking.id).then(({data}) => this.zones = data);
      return this;
    },
    loadCoworking() {
      this.$api.coworking.item(this.getUser.coworking.id).then(({data}) => this.background = data.plan_image);
      return this;
    },
    loadWorkplaces() {
      this.$api.admin.workplace.list().then(({data}) => this.workplaces = data);
      return this;
    }
  }
}
</script>


<style scoped lang="scss">
.c_p {
  cursor: pointer;

  &:hover {
    opacity: .8;
  }
}

.place {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  div {
    width: 100%;
    height: 100%;
  }

  svg {
    width: auto;
    height: calc(100vh - 270px);
    max-height: 70vw;
  }
}

.bottom {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 30px;

  div.bottom__item {
    width: auto;
    margin-right: 40px;
    display: flex;
    align-items: center;

    .circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
}

</style>

<style lang="scss">

.workplaces {
  circle {
    transition: .5s;

    &:hover {
      cursor: pointer;
    }
  }

  &.selected {
    circle {
      stroke: #000000;
      stroke-width: 1px;
    }
  }
}

.chosenCircle {
  position: relative;
  z-index: 99;

  circle {
    fill: #000000;
  }
}

.hoverable_circle {
  cursor: pointer;
}
</style>
